<template>
  <div v-bind="{ ...wrapper.attr, ...$attrs }">
    <v-btn
      v-if="button.attr.icon"
      v-bind="button.attr"
      @click.prevent="$emit('click', $event)"
      :disabled="disabled"
      :loading="loading"
    >
      <slot>
        <v-icon>{{ $lt(button.text) }}</v-icon>
      </slot>
    </v-btn>
    <v-btn
      v-else
      v-bind="button.attr"
      @click.prevent="$emit('click', $event)"
      :disabled="disabled"
      :loading="loading"
    >
      <slot>
        {{ $lt(button.text) }}
      </slot>
    </v-btn>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    value: Object,
    disabled: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      innerValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.innerValue = newValue;
    },
  },
  mounted() {},
  methods: {},
  computed: {
    wrapper() {
      const margin =
        this.innerValue.attr.style && this.innerValue.attr.style.margin
          ? this.innerValue.attr.style.margin
          : false;
      return {
        attr: {
          style: {
            margin
          },
        },
      };
    },
    button() {
      const sizePx = this.innerValue.attr.sizePx;
      const baseStyle = _.omit(this.innerValue.attr.style, ["margin"]);
      const height = sizePx ? sizePx + 'px' : (baseStyle && baseStyle.height);
      const squareStyle = height ? { width: height, minWidth: height, height } : {};
      const styleNoMargin = {
        ...baseStyle,
        ...squareStyle,
      };
      const omitKeys = sizePx
        ? ["xSmall", "small", "large", "xLarge", "sizePx", "style"]
        : ["xSmall", "small", "xLarge", "style"];
      const attrs = _.omit(this.innerValue.attr, omitKeys);
      return {
        ...this.innerValue,
        attr: {
          ...attrs,
          style: {
            ...styleNoMargin,
          },
        },
      };
    },
  },
};
</script>
